<footer class="aic-landing-footer border-top bg-light text-secondary">
  <div class="container py-5">
    <div class="row g-4 g-lg-5">
      <div class="col-lg-5">
        <router-link to="/" class="d-inline-flex flex-column text-decoration-none mb-4" aria-label="AI Campus Data Intelligence home">
          <strong class="d-block text-dark display-6 fw-bold lh-1">AI Campus</strong>
          <small class="d-block text-danger text-uppercase fw-bold fs-6">Data Intelligence</small>
        </router-link>

        <p class="text-secondary fs-5 mb-4">
          Property intelligence for utilities, connectivity, security, and portfolio teams who need clear operational signal.
        </p>

        <router-link to="/login" class="btn btn-danger rounded-pill px-4 py-2 fw-semibold">
          Enter platform <i class="bi bi-arrow-up-right ms-2"></i>
        </router-link>
      </div>

      <div class="col-sm-6 col-lg-3">
        <h2 class="h6 fw-bold text-dark mb-3">Explore</h2>
        <ul class="list-unstyled d-grid gap-2 mb-0">
          <li v-for="link in footer_links" :key="link.label">
            <a class="link-secondary link-offset-2 link-underline-opacity-0 link-underline-opacity-75-hover" :href="link.href">{{ link.label }}</a>
          </li>
        </ul>
      </div>

      <div class="col-sm-6 col-lg-2">
        <h2 class="h6 fw-bold text-dark mb-3">Account</h2>
        <ul class="list-unstyled d-grid gap-2 mb-0">
          <li v-for="link in platform_links" :key="link.label">
            <router-link class="link-secondary link-offset-2 link-underline-opacity-0 link-underline-opacity-75-hover" :to="link.to">{{ link.label }}</router-link>
          </li>
        </ul>
      </div>

      <div class="col-lg-2">
        <h2 class="h6 fw-bold text-dark mb-3">Focus</h2>
        <div class="d-flex flex-wrap gap-2">
          <span class="badge rounded-pill text-bg-light border px-3 py-2">Portfolio</span>
          <span class="badge rounded-pill text-bg-light border px-3 py-2">Energy</span>
          <span class="badge rounded-pill text-bg-light border px-3 py-2">Sites</span>
        </div>
      </div>
    </div>

    <hr class="my-4">

    <div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
      <small class="text-secondary">&copy; {{ rights.year }} {{ rights.company_name }}. All rights reserved.</small>
      <small class="text-secondary">Data intelligence, connected.</small>
    </div>
  </div>
</footer>
